
$(document).ready(function () {
	var
		ua = navigator.userAgent.toLowerCase(),
		event = (ua.match(/Android/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i)) ? "touchstart" : "click",
		isMobile = ua.match(/(iphone|ipod|ipad|android)/),
		window_w = $(window).width(),
		window_h = $(window).height(),
		is_home = $('body').hasClass('ishome');

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}

	// === Social Media Share Links ===
	let title = "";
	let url = window.location.href;
	$('[data-share-facebook').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + url + '%2F&title=' + title + '%3F');
	$('[data-share-facebook').attr('target', '_blank');
	$('[data-share-twitter').attr('href', 'https://twitter.com/share?url=' + url + '%2F&title=' + title + '&summary=');
	$('[data-share-twitter').attr('target', '_blank');
	$('[data-share-linkedin').attr('href', 'https://www.linkedin.com/shareArticle?mini=true&url=' + url + '%2F&title=' + title + '&summary=');
	$('[data-share-linkedin').attr('target', '_blank');

	/**
	 * Embed responsive
	 */
	var iframe = $('.text iframe');
	if (iframe.length) {
		iframe.wrap("<div class='embed'></div>");
	}

	/**
	 * Trigger AOS
	 */
	setTimeout(function () {
		$('#loader').fadeOut(500, function () {
			$(this).remove();
		});
	}, 300);

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
		/**
		 * init
		 * run on load and whenever necessary, for example, after an ajax call
		 * elements: pass the class of the elements to be lazy loaded (e.g. .lazy)
		 * ex: velcroLazy.init('.lazy');
		 */
		init: (elements) => {
			let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) {//is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function () {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function () {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) {//is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					} else {//is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
		}
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');
	function smoothScrollingTo(target) {
		var isTour = $('body').hasClass('tour-template-default');
		var offset = isTour ? 0 : $('.navbar-component').outerHeight();
		var target = $(target);
		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - offset
			}, 500, "swing");
		}
	}

	$(document).on('click', 'a[href*=\\#]:not([href*=\\#w-tabs])', function (event) {
		smoothScrollingTo(this.hash);
	});

	/**
	 * Privacy / legal content: build table of contents from [fs-toc-element="contents"] headings (h2–h6)
	 */
	function buildPrivacyTOC() {
		$('.privacy-content-component').each(function () {
			var $comp = $(this);
			var $contents = $comp.find('[fs-toc-element="contents"]');
			var $tocContainer = $comp.find('.privacy-content-link-content');
			if (!$contents.length || !$tocContainer.length) return;

			var usedIds = {};
			function ensureId($el) {
				var id = $el.attr('id');
				if (id) return id;
				var text = $el.text().trim();
				var base = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
				var slug = base;
				var n = 0;
				while (usedIds[slug]) { n++; slug = base + '-' + n; }
				usedIds[slug] = true;
				$el.attr('id', slug);
				return slug;
			}

			var selector = 'h2, h3, h4, h5, h6';
			var headings = [];
			$contents.find(selector).each(function () {
				var $h = $(this);
				var level = parseInt(this.tagName.charAt(1), 10);
				var id = ensureId($h);
				headings.push({ level: level, id: id, text: $h.text().trim() });
			});

			if (!headings.length) return;

			function treeFromHeadings(items) {
				var stack = [];
				var root = { level: 0, children: [] };
				stack.push(root);
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					var node = { level: item.level, id: item.id, text: item.text, children: [] };
					while (stack.length > 1 && stack[stack.length - 1].level >= item.level) stack.pop();
					stack[stack.length - 1].children.push(node);
					stack.push(node);
				}
				return root.children;
			}

			function renderItem(node, isFirst) {
				var level = node.level;
				var isH2 = level === 2;
				var linkClass = 'privacy-content-table-link w-inline-block' + (isH2 ? '' : ' is-h' + level);
				if (isFirst) linkClass += ' current';
				var html = '<div class="privacy-content-link-wrapper is-h' + level + '">';
				html += '<a href="#' + node.id + '" class="' + linkClass + '">';
				html += '<div fs-toc-element="link" class="text-size-medium truncate-width">' + $('<div>').text(node.text).html() + '</div>';
				html += '</a>';
				if (isH2) html += '<div fs-toc-element="ix-trigger" class="privacy-content-h-trigger"></div>';
				if (node.children.length) {
					for (var j = 0; j < node.children.length; j++) {
						html += renderItem(node.children[j], false);
					}
				}
				html += '</div>';
				return html;
			}

			var tree = treeFromHeadings(headings);
			var tocHtml = '';
			for (var k = 0; k < tree.length; k++) {
				tocHtml += renderItem(tree[k], k === 0);
			}
			$tocContainer.empty().append(tocHtml);

			// Scroll spy: highlight TOC link when its heading reaches the middle of the viewport
			var $headingEls = $contents.find(selector);
			function setCurrentTOCLink() {
				var viewportCenterY = window.innerHeight / 2;
				var currentId = null;
				$headingEls.each(function () {
					var rect = this.getBoundingClientRect();
					if (rect.top <= viewportCenterY) currentId = this.id;
				});
				$tocContainer.find('a.privacy-content-table-link').each(function () {
					if (this.getAttribute('href') === '#' + currentId) {
						$(this).addClass('current');
					} else {
						$(this).removeClass('current');
					}
				});
			}
			var spyObserver = new IntersectionObserver(function () {
				setCurrentTOCLink();
			}, {
				root: null,
				rootMargin: '-50% 0px -50% 0px',
				threshold: 0
			});
			$headingEls.each(function () { spyObserver.observe(this); });
			setCurrentTOCLink(); // set initial state
		});
	}

	if ($('.section-privacy-content').length) {
		buildPrivacyTOC();
	}

	smoothScrollingTo(location.hash);

	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}

	$(".slider-main_component").each(function (index) {
		let loopMode = false;
		if ($(this).attr("loop-mode") === "true") {
			loopMode = true;
		}
		let sliderDuration = 300;
		if ($(this).attr("slider-duration") !== undefined) {
			sliderDuration = +$(this).attr("slider-duration");
		}

		// --- Swiper Testimonials
		const swiperTestimonials = new Swiper($(this).find(".swiper.is-testimonial")[0], {
			speed: sliderDuration,
			spaceBetween: 12,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			rewind: false,
			autoplay: {
				delay: 8000,
				disableOnInteraction: false,
				waitForTransition: true,
				pauseOnMouseEnter: false,
			},
			mousewheel: {
				forceToAxis: true
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			pagination: {
				el: $(this).find(".swiper-bullet-wrapper")[0],
				bulletActiveClass: "is-active",
				bulletClass: "swiper-bullet",
				bulletElement: "button",
				clickable: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
	});

});

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}

// Disable Webflow smooth scroll
var Webflow = Webflow || [];
Webflow.push(function () {
	$(function () {
		$(document).off('click.wf-scroll');
	});
});

var Webflow = Webflow || [];
Webflow.push(function () {

	// unbind webflow form handling
	$(document).off('submit');

});

// === Copy URL Functionality ===
const copyButton = document.getElementById("copy-url");
if (copyButton) {
	copyButton.addEventListener("click", async function (event) {
		event.preventDefault();
		const url = window.location.href;
		// Use modern Clipboard API if available
		if (navigator.clipboard && window.isSecureContext) {
			try {
				await navigator.clipboard.writeText(url);
				alert("Link copied to clipboard successfully!");
			} catch (err) {
				// Fallback to execCommand if clipboard API fails
				fallbackCopy(url);
			}
		} else {
			// Fallback for older browsers
			fallbackCopy(url);
		}
	});
}

function fallbackCopy(text) {
	try {
		const textarea = document.createElement("textarea");
		textarea.value = text;
		textarea.style.position = "fixed";
		textarea.style.left = "-999999px";
		textarea.style.top = "-999999px";
		document.body.appendChild(textarea);
		textarea.focus();
		textarea.select();
		const successful = document.execCommand("copy");
		document.body.removeChild(textarea);
		if (successful) {
			alert("Link copied to clipboard successfully!");
		} else {
			throw new Error("execCommand('copy') returned false");
		}
	} catch (err) {
		alert("Could not copy link to clipboard");
	}
}

document.addEventListener("DOMContentLoaded", function () {
	const modalSystem = ((window.lumos ??= {}).modal ??= {
		list: {},
		open(id) {
			this.list[id]?.open?.();
		},
		closeAll() {
			Object.values(this.list).forEach((m) => m.close?.());
		},
	});

	function createModals() {
		document.querySelectorAll(".modal_dialog").forEach(function (modal) {
			if (modal.dataset.scriptInitialized) return;
			modal.dataset.scriptInitialized = "true";
			const modalId = modal.getAttribute("data-modal-target");
			let lastFocusedElement;
			if (typeof gsap !== "undefined") {
				gsap.context(() => {
					let tl = gsap.timeline({
						paused: true,
						onReverseComplete: resetModal
					});
					tl.fromTo(modal, {
						opacity: 0
					}, {
						opacity: 1,
						duration: 0.3,
						ease: "power1.out"
					});
					if (modal.querySelector('.modal_content').classList.contains('is-side')) {
						tl.from(".modal_content.is-side", {
							x: "6rem",
							duration: 0.3,
							ease: "power1.out"
						}, "<");
					} else {
						tl.from(".modal_content", {
							y: "6rem",
							duration: 0.3,
							ease: "power1.out"
						}, "<");
					}
					modal.tl = tl;
				}, modal);
			}

			function resetModal() {
				typeof lenis !== "undefined" && lenis.start ? lenis.start() : (document.body.style.overflow = "");
				modal.close();
				if (lastFocusedElement) lastFocusedElement.focus();
				window.dispatchEvent(new CustomEvent("modal-close", {
					detail: {
						modal
					}
				}));
			}

			function openModal() {
				typeof lenis !== "undefined" && lenis.stop ? lenis.stop() : (document.body.style.overflow = "hidden");
				lastFocusedElement = document.activeElement;
				modal.showModal();
				if (typeof gsap !== "undefined") modal.tl.play();
				modal.querySelectorAll("[data-modal-scroll]").forEach((el) => (el.scrollTop = 0));
				window.dispatchEvent(new CustomEvent("modal-open", {
					detail: {
						modal
					}
				}));
			}

			function closeModal() {
				typeof gsap !== "undefined" ? modal.tl.reverse() : resetModal();
			}
			if (new URLSearchParams(location.search).get("modal-id") === modalId) openModal(), history.replaceState({}, "", ((u) => (u.searchParams.delete("modal-id"), u))(new URL(location.href)));
			modal.addEventListener("cancel", (e) => (e.preventDefault(), closeModal()));
			modal.addEventListener("click", (e) => e.target.closest("[data-modal-close]") && closeModal());
			document.addEventListener("click", (e) => e.target.closest("[data-modal-trigger='" + modalId + "']") && openModal());
			modalSystem.list[modalId] = {
				open: openModal,
				close: closeModal
			};
		});
	}
	createModals();

	convertSvgs();
});

// ============================================================================
// Initialization State Management
// ============================================================================
const initState = {
	svgConversion: { initialized: false, inProgress: false },
};
// ============================================================================
// SVG Conversion (with concurrency protection)
// ============================================================================
function convertSvgs() {
	// Select all svg images that haven't been processed
	const svgImgs = document.querySelectorAll("[data-convert-svg='true'] img");
	if (svgImgs.length === 0) {
		return;
	}
	svgImgs.forEach(img => {
		// Mark as being processed to prevent duplicate processing
		img.setAttribute("data-svg-processed", "processing");
		const src = img.getAttribute("src");
		if (!src || !src.endsWith(".svg")) {
			return;
		}
		fetch(src)
			.then(res => {
				if (!res.ok) throw new Error(`Failed to fetch ${src}: ${res.status}`);
				return res.text();
			})
			.then(svgText => {
				// Check if image still exists in DOM (may have been removed)
				if (!img.parentNode) {
					return;
				}
				const parser = new DOMParser();
				const svgDoc = parser.parseFromString(svgText, "image/svg+xml");
				const svgEl = svgDoc.querySelector("svg");
				if (!svgEl) {
					return;
				}
				// Copy over any existing classes
				const existingClasses = img.getAttribute("class");
				if (existingClasses) {
					svgEl.setAttribute("class", existingClasses);
				}
				svgEl.removeAttribute("width");
				svgEl.removeAttribute("height");
				// Force fill/stroke to currentColor
				svgEl.querySelectorAll("*").forEach(el => {
					if (el.hasAttribute("fill") && el.getAttribute("fill") !== "none") {
						el.setAttribute("fill", "currentColor");
					}
					if (el.hasAttribute("stroke") && el.getAttribute("stroke") !== "none") {
						el.setAttribute("stroke", "currentColor");
					}
				});
				// Replace the <img> with inline SVG atomically
				if (img.parentNode) {
					img.replaceWith(svgEl);
				}
			})
			.catch(err => {
				console.error("SVG inline error:", err);
				// Mark image as failed to prevent retry loops
				if (img.parentNode) {
					img.setAttribute("data-svg-processed", "failed");
				}
			});
	});
}

//  Transition Trigger 
let transitionTrigger = $(".transition-trigger");
let introDurationMS = 0;
let exitDurationMS = 900;
let excludedClass = "no-transition";
/*// On Page Load
window.addEventListener("DOMContentLoaded", (event) => {
if (transitionTrigger.length > 0) {
  Webflow.push(function () {
	transitionTrigger.click();
  });
  $("body").addClass("no-scroll-transition");
  setTimeout(() => {$("body").removeClass("no-scroll-transition");}, introDurationMS);
}
});*/
// On Link Click
$("a").on("click", function (e) {
	if ($(this).prop("hostname") == window.location.host && $(this).attr("href").indexOf("#") === -1 &&
		!$(this).hasClass(excludedClass) && $(this).attr("target") !== "_blank" && transitionTrigger.length > 0) {
		e.preventDefault();
		$("body").addClass("no-scroll-transition");
		let transitionURL = $(this).attr("href");
		transitionTrigger.click();
		setTimeout(function () { window.location = transitionURL; }, exitDurationMS);
	}
});
// On Back Button Tap
window.onpageshow = function (event) { if (event.persisted) { window.location.reload() } };
// Hide Transition on Window Width Resize
setTimeout(() => {
	$(window).on("resize", function () {
		setTimeout(() => { $(".transition").css("display", "none"); }, 50);
	});
}, introDurationMS);


document.addEventListener("DOMContentLoaded", function () {
	if ($("#marcacoes-form").length) {
		var marcacoesI18n = window.marcacoes_form_i18n || {};
		var marcacoesPreset = window.marcacoes_form_preset || {};
		var appMarcacoes = new Vue({
			el: "#marcacoes-form",
			data: {
				i18n: marcacoesI18n,
				presetEquipa: marcacoesPreset.equipa_id || null,
				presetEquipaLabel: marcacoesPreset.equipa_label || "",
				presetServico: marcacoesPreset.servico_id || null,
				presetServicoLabel: marcacoesPreset.servico_label || "",
				clinicas: [],
				servicos: [],
				profissionais: [],
				clinica: "",
				servico: "",
				profissional: "",
				loading: {
					clinicas: false,
					servicos: false,
					profissionais: false,
				},
				feedback: {
					message: "",
					success: false,
				},
				processing: false,
			},
			computed: {
				presetHints: function () {
					var hints = [];
					if (this.presetEquipaLabel && this.i18n.bookingWith) {
						hints.push(this.i18n.bookingWith.replace("%s", this.presetEquipaLabel));
					}
					if (this.presetServicoLabel && this.i18n.bookingService) {
						hints.push(this.i18n.bookingService.replace("%s", this.presetServicoLabel));
					}
					return hints;
				},
				servicoDisabled: function () {
					return !this.clinica || this.loading.servicos;
				},
				profissionalDisabled: function () {
					return !this.servico || this.loading.profissionais;
				},
				clinicaPlaceholder: function () {
					return this.loading.clinicas ? this.i18n.loading : this.i18n.chooseClinic;
				},
				servicoPlaceholder: function () {
					if (!this.clinica) {
						return this.i18n.selectClinicFirst;
					}
					if (this.loading.servicos) {
						return this.i18n.loading;
					}
					if (!this.servicos.length) {
						return this.i18n.noServices;
					}
					return this.i18n.chooseService;
				},
				profissionalPlaceholder: function () {
					if (!this.servico) {
						return this.i18n.selectServiceFirst;
					}
					if (this.loading.profissionais) {
						return this.i18n.loading;
					}
					if (!this.profissionais.length) {
						return this.i18n.noProfessionals;
					}
					return this.i18n.chooseProfessional;
				},
			},
			watch: {
				clinica: function (id) {
					this.servico = "";
					this.profissional = "";
					this.servicos = [];
					this.profissionais = [];
					if (!id) {
						return;
					}
					this.fetchServicos(id);
				},
				servico: function (id) {
					this.profissional = "";
					this.profissionais = [];
					if (!id || !this.clinica) {
						return;
					}
					this.fetchProfissionais(this.clinica, id);
				},
			},
			mounted: function () {
				this.fetchClinicas();
			},
			methods: {
				getPresetParams: function () {
					var params = {};
					if (this.presetEquipa) {
						params.equipa_id = this.presetEquipa;
					}
					if (this.presetServico) {
						params.servico_id = this.presetServico;
					}
					return params;
				},
				selectPresetServico: function (servicos) {
					if (!this.presetServico || !servicos.length) {
						return;
					}
					var presetId = parseInt(this.presetServico, 10);
					var match = servicos.some(function (item) {
						return parseInt(item.id, 10) === presetId;
					});
					if (match) {
						this.servico = presetId;
					}
				},
				selectPresetProfissional: function (profissionais) {
					if (!this.presetEquipa || !profissionais.length) {
						return;
					}
					var presetId = parseInt(this.presetEquipa, 10);
					var match = profissionais.some(function (item) {
						return parseInt(item.id, 10) === presetId;
					});
					if (match) {
						this.profissional = presetId;
					}
				},
				fetchOptions: function (action, params) {
					return $.getJSON(
						main_script.ajaxurl,
						$.extend({ action: action }, params || {})
					).then(function (r) {
						return r.success ? r.data : [];
					});
				},
				fetchClinicas: function () {
					var vm = this;
					vm.loading.clinicas = true;
					vm.fetchOptions(
						"form_marcacoes_get_clinicas",
						vm.getPresetParams()
					)
						.done(function (data) {
							vm.clinicas = data;
						})
						.always(function () {
							vm.loading.clinicas = false;
						});
				},
				fetchServicos: function (clinicaId) {
					var vm = this;
					vm.loading.servicos = true;
					vm.fetchOptions(
						"form_marcacoes_get_servicos",
						$.extend({ clinica_id: clinicaId }, vm.getPresetParams())
					)
						.done(function (data) {
							vm.servicos = data;
							vm.selectPresetServico(data);
						})
						.always(function () {
							vm.loading.servicos = false;
						});
				},
				fetchProfissionais: function (clinicaId, servicoId) {
					var vm = this;
					vm.loading.profissionais = true;
					vm.fetchOptions("form_marcacoes_get_profissionais", {
						clinica_id: clinicaId,
						servico_id: servicoId,
					})
						.done(function (data) {
							vm.profissionais = data;
							vm.selectPresetProfissional(data);
						})
						.always(function () {
							vm.loading.profissionais = false;
						});
				},
				resetCascade: function () {
					this.clinica = "";
					this.servico = "";
					this.profissional = "";
					this.servicos = [];
					this.profissionais = [];
					this.fetchClinicas();
				},
				submitFormMarcacoes: function () {
					var vm = this;
					var $container = $(vm.$el);
					var $form = $container.find("form");

					if (!vm.clinica || !vm.servico || !vm.profissional) {
						vm.feedback.message = vm.i18n.fillAllFields;
						vm.feedback.success = false;
						return;
					}

					vm.processing = true;
					vm.feedback.message = "";
					vm.feedback.success = false;

					grecaptcha.ready(function () {
						grecaptcha
							.execute(main_script.recaptcha_site_key, {
								action: "marcacoes",
							})
							.then(function (token) {
								var fields = $form.serialize();

								fields += "&action=form_marcacoes";
								fields += "&token=" + token;

								$.ajax({
									url: main_script.ajaxurl,
									type: "POST",
									data: fields,
									dataType: "json",
									success: function (r) {
										if (r.success) {
											$form[0].reset();
											$form.find(".w-checkbox-input").removeClass("w--redirected-checked");
											vm.resetCascade();
										}
										vm.feedback.message = r.data;
										vm.feedback.success = r.success;
									},
									error: function (xhr) {
										vm.feedback.message = xhr.responseJSON
											? xhr.responseJSON.data
											: vm.i18n.submitError;
										vm.feedback.success = false;
									},
									complete: function () {
										vm.processing = false;
									},
								});
							})
							.catch(function () {
								vm.feedback.message = vm.i18n.recaptchaError;
								vm.feedback.success = false;
								vm.processing = false;
							});
					});
				},
			},
		});
	}

	if ($("#fale-equipa-form").length) {
		var faleEquipaI18n = window.fale_equipa_form_i18n || {};

		var appFaleEquipa = new Vue({
			el: "#fale-equipa-form",

			data: {
				i18n: faleEquipaI18n,
				feedback: {
					message: "",
					success: false,
				},
				processing: false,
			},

			methods: {
				submitFormFaleEquipa: function () {
					var vm = this;
					var $container = $(vm.$el);
					var $form = $container.find("form");

					vm.processing = true;
					vm.feedback.message = "";
					vm.feedback.success = false;

					grecaptcha.ready(function () {
						grecaptcha
							.execute(main_script.recaptcha_site_key, {
								action: "fale_equipa",
							})
							.then(function (token) {
								var fields = $form.serialize();

								fields += "&action=form_fale_equipa";
								fields += "&token=" + token;

								$.ajax({
									url: main_script.ajaxurl,
									type: "POST",
									data: fields,
									dataType: "json",

									success: function (r) {
										if (r.success) {
											$form[0].reset();

											$form
												.find(".w-checkbox-input")
												.removeClass(
													"w--redirected-checked"
												);
										}

										vm.feedback.message = r.data;
										vm.feedback.success = r.success;
									},

									error: function (xhr) {
										vm.feedback.message = xhr.responseJSON
											? xhr.responseJSON.data
											: vm.i18n.submitError;

										vm.feedback.success = false;
									},

									complete: function () {
										vm.processing = false;
									},
								});
							})
							.catch(function () {
								vm.feedback.message = vm.i18n.recaptchaError;
								vm.feedback.success = false;
								vm.processing = false;
							});
					});
				},
			},
		});
	}

	if ($("#pedir-informacoes-form").length) {
		var pedirInformacoesI18n = window.pedir_informacoes_form_i18n || {};
		var appPedirInformacoes = new Vue({
			el: "#pedir-informacoes-form",
			data: {
				i18n: pedirInformacoesI18n,
				feedback: {
					message: "",
					success: false,
				},
				processing: false,
			},
			methods: {
				submitFormPedirInformacoes: function () {
					var vm = this;
					var $container = $(vm.$el);
					var $form = $container.find("form");

					vm.processing = true;
					vm.feedback.message = "";
					vm.feedback.success = false;

					grecaptcha.ready(function () {
						grecaptcha
							.execute(main_script.recaptcha_site_key, { action: "pedir_informacoes" })
							.then(function (token) {
								var fields = $form.serialize();
								fields += "&action=form_pedir_informacoes";
								fields += "&token=" + token;

								$.ajax({
									url: main_script.ajaxurl,
									type: "POST",
									data: fields,
									dataType: "json",
									success: function (r) {
										if (r.success) {
											$form[0].reset();
											$form.find(".w-checkbox-input").removeClass("w--redirected-checked");
										}
										vm.feedback.message = r.data;
										vm.feedback.success = r.success;
									},
									error: function (xhr) {
										vm.feedback.message = xhr.responseJSON
											? xhr.responseJSON.data
											: vm.i18n.submitError;
										vm.feedback.success = false;
									},
									complete: function () {
										vm.processing = false;
									},
								});
							})
							.catch(function () {
								vm.feedback.message = vm.i18n.recaptchaError;
								vm.feedback.success = false;
								vm.processing = false;
							});
					});
				},
			},
		});
	}

	if ($("#informacoes-eventos-form").length) {
		var pedirInformacoesI18n = window.informacoes_eventos_form_i18n || {};
		var appPedirInformacoes = new Vue({
			el: "#informacoes-eventos-form",
			data: {
				i18n: pedirInformacoesI18n,
				feedback: {
					message: "",
					success: false,
				},
				processing: false,
			},
			methods: {
				submitFormInformacoesEventos: function () {
					var vm = this;
					var $container = $(vm.$el);
					var $form = $container.find("form");

					vm.processing = true;
					vm.feedback.message = "";
					vm.feedback.success = false;

					grecaptcha.ready(function () {
						grecaptcha
							.execute(main_script.recaptcha_site_key, { action: "pedir_informacoes" })
							.then(function (token) {
								var fields = $form.serialize();
								fields += "&action=form_informacoes_eventos";
								fields += "&token=" + token;

								$.ajax({
									url: main_script.ajaxurl,
									type: "POST",
									data: fields,
									dataType: "json",
									success: function (r) {
										if (r.success) {
											$form[0].reset();
											$form.find(".w-checkbox-input").removeClass("w--redirected-checked");
										}
										vm.feedback.message = r.data;
										vm.feedback.success = r.success;
									},
									error: function (xhr) {
										vm.feedback.message = xhr.responseJSON
											? xhr.responseJSON.data
											: vm.i18n.submitError;
										vm.feedback.success = false;
									},
									complete: function () {
										vm.processing = false;
									},
								});
							})
							.catch(function () {
								vm.feedback.message = vm.i18n.recaptchaError;
								vm.feedback.success = false;
								vm.processing = false;
							});
					});
				},
			},
		});
	}

	if ($("#contact-form").length) {
		var contactosI18n = window.contactos_form_i18n || {};

		var appContactos = new Vue({
			el: "#contact-form",

			data: {
				i18n: contactosI18n,
				feedback: {
					message: "",
					success: false,
				},
				processing: false,
			},

			methods: {
				submitFormContact: function () {
					var vm = this;
					var $container = $(vm.$el);
					var $form = $container.find("form");

					vm.processing = true;
					vm.feedback.message = "";
					vm.feedback.success = false;

					grecaptcha.ready(function () {
						grecaptcha
							.execute(main_script.recaptcha_site_key, {
								action: "contactos",
							})
							.then(function (token) {
								var fields = $form.serialize();

								fields += "&action=form_contactos";
								fields += "&token=" + token;

								$.ajax({
									url: main_script.ajaxurl,
									type: "POST",
									data: fields,
									dataType: "json",

									success: function (r) {
										if (r.success) {
											$form[0].reset();

											$form
												.find(".w-checkbox-input")
												.removeClass("w--redirected-checked");
										}

										vm.feedback.message = r.data;
										vm.feedback.success = r.success;
									},

									error: function (xhr) {
										vm.feedback.message = xhr.responseJSON
											? xhr.responseJSON.data
											: vm.i18n.submitError;

										vm.feedback.success = false;
									},

									complete: function () {
										vm.processing = false;
									},
								});
							})
							.catch(function () {
								vm.feedback.message = vm.i18n.recaptchaError;
								vm.feedback.success = false;
								vm.processing = false;
							});
					});
				},
			},
		});
	}
});